import type { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { Box, TextField, Typography } from '@mui/material';

import type { FormikScheme } from 'src/schemes/formik';

import { styles } from './index.styles';

export const PASSWORD_RESET_CONFIRM_SUBMIT_BUTTON_TEST_ID =
  'password-reset-confirm-submit-button';
interface PasswordResetConfirmFormProps extends FormikScheme {
  className?: string;
  errors: {
    password1?: string;
    password2?: string;
    nonFieldErrors?: string | [string];
  };
  isSubmitting: boolean;
  touched: {
    password1?: boolean;
    password2?: boolean;
  };
  values: {
    password1: string;
    password2: string;
  };
  onBlur?: (event: ChangeEvent) => void;
}

const PasswordResetConfirmForm: FC<PasswordResetConfirmFormProps> = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
}) => {
  const { t } = useTranslation(['login']);

  return (
    <Box sx={{ width: '100%' }}>
      <form onSubmit={handleSubmit}>
        <TextField
          placeholder={t('password')}
          type="password"
          name="password1"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password1}
          required
          sx={styles.inputField}
          fullWidth
          helperText={
            (touched.password1 && t(errors.password1 as string)) || <>&nbsp;</>
          }
          error={touched.password1 && !!errors.password1}
        />

        <TextField
          placeholder={t('repeatPassword')}
          type="password"
          name="password2"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password2}
          required
          sx={styles.inputField}
          fullWidth
          helperText={
            (touched.password2 && t(errors.password2 as string)) || <>&nbsp;</>
          }
          error={touched.password2 && !!errors.password2}
        />
        <Box sx={{ width: '20rem', mb: 2, mt: 2 }}>
          <LoadingButton
            variant="cta"
            fullWidth
            loading={isSubmitting}
            onClick={handleSubmit}
            type="submit"
            data-test-id={PASSWORD_RESET_CONFIRM_SUBMIT_BUTTON_TEST_ID}
          >
            {t('submitButton')}
          </LoadingButton>
        </Box>
        <Typography sx={styles.errorMsg}>{errors.nonFieldErrors}</Typography>
      </form>
    </Box>
  );
};

export default PasswordResetConfirmForm;
